// https://deo.shopeesz.com/shopee/shopee-seller-live-sg/tsp/api/
// https://deo.shopeemobile.com/shopee/shopee-seller-live-sg/tsp/api/

import { Region } from '..';

const getSuffix = (env: string, sep: string) => ['live', 'stable'].includes(env) ? '' : sep + 'nonlive';

export const apiBase = (env: string, cn: boolean, region: Region ) => {
  const s = getSuffix(env, '/');
  if (cn) {
    return `https://seller.sg.shopee.cn/api/tsp${s}`;
  } else if (region === 'br') {
    return `https://seller.shopee.com.br/api/tsp${s}`;
  }
  return `https://seller.shopee.sg/api/tsp${s}`;
}

export const cdnBase = (env: string, cn: boolean) => {
  const s = getSuffix(env, '-');
  return `https://deo.shopee${cn ? 'sz' : 'mobile'}.com/shopee/shopee-seller-live-sg/tsp/api${s}`
}
